import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";
import BetItemActions from "./BetItemActions";
import BetStatus from "./BetStatus";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetItemCardHeader() {
	const bet = useContext(MyBetsBetContext);

	if (!bet.betStatus) {
		return null;
	}

	return (
		<div className={classNames("card--bet__title")}>
			<BetStatus />
			<BetItemActions />
		</div>
	);
});
